import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseAdministratorAccess from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAdministratorAccess';
import {useTranslation} from 'react-i18next';
import {administratorsAccessIcon} from "../../../../assets/images/headerIcons";
const pageSchema = GatewayGetSchema.pages.administratorAccess;
const pageId = pageSchema.pageId;

function GatewayAdministratorAccess({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);
    }, [setGatewayData, planPage]);


    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.PLAN.ADMIN_ACCESS_WIZ.ADMIN_ACCESS')}
            icon={administratorsAccessIcon}
        >
            <BaseAdministratorAccess
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
    );
}

export default GatewayAdministratorAccess;